/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any  */

import React from "react";
import GridUI from "@material-ui/core/Grid";

export const Grid = (props: any): React.ReactElement => <GridUI {...props} />;
